export class RefreshTokenReadError extends Error {}
